import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static override targets = ["selectedValueInput", "display", "popover"];

    declare selectedValueInputTarget: HTMLInputElement;
    declare displayTarget: HTMLElement;
    declare popoverTarget: HTMLElement;

    public selectOption(event: Event) {
        const target = event.target as HTMLInputElement;
        this.selectedValueInputTarget.value = target.value;
        this.displayTarget.textContent = target.dataset.label ?? target.value;
        this.selectedValueInputTarget.dispatchEvent(new Event('change', {bubbles: true}));
    }
}
